import React from "react";
import { NavLink } from "react-router-dom";

import "./navbar_links.css";

export const NavbarLink = ({ to, children }) => {
  return (
    <NavLink
      className="navbar__navbarLink"
      activeClassName="navbar__navbarLink--active"
      to={to}
    >
      {children}
    </NavLink>
  );
};

export const NavbarLinkEmployee = ({ to, children }) => {
  return (
    <NavLink
      className="navbar__navbarLinkEmployee"
      activeClassName="navbar__navbarLinkEmployee--active"
      exact={true}
      to={to}
    >
      {children}
    </NavLink>
  );
};

export const ToggleSideNavBtn = ({ isOpen, onClick }) => {
  return (
    <button
      className={`navbar__toggleSidenavBtn ${
        isOpen
          ? "navbar__toggleSidenavBtn--open"
          : "navbar__toggleSidenavBtn--closed"
      }`}
      title={!isOpen ? "Open menu" : "Close menu"}
      onMouseDown={onClick}
    >
      <span className="navbar__toggleSidenavBtn__line" />
      <span className="navbar__toggleSidenavBtn__line" />
      <span className="navbar__toggleSidenavBtn__line" />
    </button>
  );
};

export const LogoutBtn = ({ onClick }) => {
  return (
    <button title="Log out" className="navbar__logoutBtn" onClick={onClick}>
      <svg
        width="4em"
        height="4em"
        viewBox="0 0 16 16"
        className="bi bi-box-arrow-right"
        fill="whitesmoke"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"
        />
        <path
          fillRule="evenodd"
          d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
        />
      </svg>
    </button>
  );
};
